# GraphQL mutation to update a stage name

#import "../fragments/sales-automation-stage.graphql"

mutation StageUpdate($stage: StageUpdateInputFieldInput!) {
    stageUpdate(input: {stage: $stage}) {
        stage {
            ...SalesAutomationStage
        }
    }
}
